export default defineNuxtRouteMiddleware((to, from) => {
  const store = useAuthStore();

  if (
    store.isAuthenticated ||
    (from.name === 'checkout-takeaway' && store.isGuest)
  ) {
    if (from.query?.redirect) {
      return navigateTo(from.query.redirect as string);
    }

    return navigateTo({ name: 'menu' });
  }
});
